import React from 'react';
import PropTypes from 'prop-types';
import { Container, List } from '@pella/sash-framework';
import { Image, CTA } from '../../';

import styles from './index.module.scss';

const ImageBanner = ({ data, className, ...other }) => {
	if (!data) return null;

	return (
		<div
			className={`${styles.imageBanner} ${data.container ? styles.imageBanner_contained : ''} ${className || ''}`}
			{...other}
		>
			{!data.container && data.gatsby_image?.[0] && (
				<Image
					data={data.gatsby_image[0]}
					className={`${styles.imageBanner_Image} !block xl:ml-auto`}
				/>
			)}

			<div className={styles.imageBanner_ContentWrapper}>
				<Container className={styles.imageBanner_Container}>
					{data.container && data.gatsby_image?.[0] && (
						<Image
							data={data.gatsby_image[0]}
							className={styles.imageBanner_Image}
						/>
					)}

					<div className={styles.imageBanner_ContentBox}>
						{data.heading && (
							<h3
								className={styles.imageBanner_Title}
								dangerouslySetInnerHTML={{
									__html: data.heading,
								}}
							/>
						)}

						{data.description && (
							<div
								className={styles.imageBanner_Description}
								dangerouslySetInnerHTML={{
									__html: data.description,
								}}
							/>
						)}

						{data.ctas?.[0] && (
							<List
								bullets='none'
								layout='inline'
								className={styles.imageBanner_Buttons}
							>
								{data.ctas.map((link, index) => (
									<li key={index}>
										<CTA
											data={link}
											className={link.gtm_link_type !== 'button' || link.button_style === 'tertiary' ? 'text-white' : null}
										/>
									</li>
								))}
							</List>
						)}
					</div>
				</Container>
			</div>
		</div>
	);
};

ImageBanner.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default ImageBanner;
